import { makeStyles } from '@fluentui/react-components';

export const HINT_WIDTH = 20;
export const useStyles = makeStyles({
  carouselParent: {
    position: 'relative',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'end',
  },

  container: {
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'inline-block',
    flexGrow: 1,
    alignSelf: 'center',
  },
  parentContainer: {
    position: 'relative',
    transitionProperty: 'left',
    transitionDuration: '0.5s',
    transitionTimingFunction: 'ease-out',
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
  },
  chevronButton: {
    alignSelf: 'center',
    position: 'inherit',
    boxShadow: '0px 4px 8px 0px #00000024',
    backgroundColor: '#FFFFFF',

    borderTopLeftRadius: '32px',
    borderTopRightRadius: '32px',
    borderBottomLeftRadius: '32px',
    borderBottomRightRadius: '32px',

    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',

    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',

    borderLeftColor: '#D1D1D1',
    borderRightColor: '#D1D1D1',
    borderTopColor: '#D1D1D1',
    borderBottomColor: '#D1D1D1',

    ':focus-visible': {
      borderLeftColor: '#000',
      borderRightColor: '#000',
      borderTopColor: '#000',
      borderBottomColor: '#000',
      backgroundColor: '#FFFFFF',
      borderLeftWidth: '2px',
      borderRightWidth: '2px',
      borderTopWidth: '2px',
      borderBottomWidth: '2px',
      height: '32px',
    },
    ':active:hover': {
      backgroundColor: '#FFFFFF',
    },
    ':hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  chevronButtonLeft: {
    zIndex: 1,
    marginRight: '2px',
    left: '20px',
  },
  chevronButtonRight: {
    right: '20px',
  },
  hintRight: {
    display: 'inline-block',
    position: 'absolute',
    backgroundImage: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: `${HINT_WIDTH}px`,
    height: '100%',
    right: '32px',
  },
  hintLeft: {
    display: 'inline-block',
    position: 'absolute',
    backgroundImage: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: `${HINT_WIDTH}px`,
    height: '100%',
    left: '34px',
    transform: 'rotate(-180deg)',
  },
});

export const useSimpleCarouselStyles = makeStyles({
  container: {
    overflowX: 'auto',
    paddingBottom: '12px',
  },
  cardContents: {
    display: 'flex',
  },
});
